import { ProFormaModelIds } from 'constants/proForma';

// eslint-disable-next-line max-len
export const isApartmentModel = (proFormaModelId: ProFormaModelIds): boolean => [ProFormaModelIds.APARTMENT, ProFormaModelIds.APARTMENT_WITH_RETAIL].includes(proFormaModelId);
